import styled, { css } from 'styled-components'

export const InteractiveCardStyled = styled.div<{ disabled?: boolean }>`
  ${({ disabled }) =>
    !disabled &&
    css`
      cursor: pointer;
    `}
`
